import { classRooms, classRoomUsers, isInstructorInSpace } from './classroom';

export const accessToken = (state, spaceId) =>
  state.accessTokens[spaceId] && state.accessTokens[spaceId].token;

export const needsToRefreshAccessToken = (state, spaceId) =>
  !state.accessTokens[spaceId] ||
  Date.now() > state.accessTokens[spaceId].expiry;

export const user = (state) => state.user;
const classRoomUser = (state) => state.classRoomUser;

export const currentUserId = (state) => user(state).userId;

export const currentUser = (state) => user(state).user;

export const currentUserSlim = (state) => {
  const { objectId, firstName, lastName, avatar } = user(state).user;
  return {
    id: objectId,
    firstName,
    lastName,
    avatar,
  };
};

export const currentUserFeatures = (state) =>
  (currentUser(state) || {}).features || {};

export const sessionToken = (state) => {
  const current = currentUser(state);
  return current && current.sessionToken;
};

export const getUserRoles = (state) =>
  (currentUser(state) || {}).userRoles || [];

export const isInstructorInAnySpace = (state) => {
  const spaces = classRooms(state);
  const spaceUsers = classRoomUsers(state);
  const userId = currentUserId(state);
  const spaceUser = classRoomUser(state);
  return spaceUser.self
    .map(
      (objectId) =>
        spaceUsers[objectId] && spaces[spaceUsers[objectId].classRoom]
    )
    .some(
      (classRoom) =>
        !!classRoom && isInstructorInSpace(state)(userId, classRoom.objectId)
    );
};

export const getUserRole = (state) => {
  const roles = getUserRoles(state);
  if (roles.includes('admin')) {
    return 'Admin';
  }
  return isInstructorInAnySpace(state) ? 'Instructor' : 'Student';
};

export const isChangingStatus = (state) => user(state).changingStatus;
